import * as React from "react";
const SvgFiRrCarTilt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car-tilt_svg__a)">
      <path
        fill="#062147"
        d="M1.673 13.937a9.9 9.9 0 0 0 1 3.2l.533 1.03A3.986 3.986 0 0 0 8.122 19.8l.145.239a1.987 1.987 0 1 0 3.405-2.05l-.066-.111 7.01-3.929.193.321a1.988 1.988 0 1 0 3.406-2.051l-.223-.37c.47-.497.802-1.107.965-1.771a3.9 3.9 0 0 0-.422-2.955L22 6.091a7.24 7.24 0 0 0-2.51-2.582L15.2.688a4.96 4.96 0 0 0-4.94.052L3.388 4.357A4.98 4.98 0 0 0 .98 8.733c.001.037.693 5.204.693 5.204M20.79 8.094a1.98 1.98 0 0 1-.663 2.713l-12.49 7a1.98 1.98 0 0 1-1.5.226 1.95 1.95 0 0 1-1.187-.843l-.533-1.03a3.6 3.6 0 0 1-.253-.526l1.663-.947.5.808a1 1 0 1 0 1.7-1.047l-.462-.748 8.968-5.107.56.929a1 1 0 0 0 1.713-1.032l-.534-.89 1.7-.968c.1.139.2.283.286.431zM4.369 6.1l6.872-3.617a2.96 2.96 0 0 1 2.925-.083l4.27 2.81-14.787 8.416-.67-4.99A2.96 2.96 0 0 1 4.369 6.1M24 23a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h22a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car-tilt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCarTilt;
